
return;


(function () {
  function $(sel) { return document.querySelector(sel); }

  // Sadece anasayfa
  function isHome() {
    return window.location.pathname === "/" || window.location.pathname === "";
  }

  // "Sayfa yenilenmediği sürece" tekrar açılmasın:
  // sessionStorage aynı sekmede kalır, tema popup'ı tekrar açsa bile engelleriz.
  const CLOSED_KEY = "nt_valentine_popup_closed";

  function getPopupEl() {
    return document.getElementById("valentine-popup") || $(".valentine-popup");
  }

  function getInnerEl(popup) {
    return popup.querySelector(".valentine-popup-inner") || popup;
  }

  function wasClosedThisSession() {
    try { return sessionStorage.getItem(CLOSED_KEY) === "1"; }
    catch (e) { return false; }
  }

  function markClosedThisSession() {
    try { sessionStorage.setItem(CLOSED_KEY, "1"); } catch (e) {}
  }

  function hidePopup(popup) {
    if (!popup) return;
    popup.style.display = "none";
    popup.setAttribute("aria-hidden", "true");
  }

  function showPopup(popup) {
    if (!popup) return;

    // Eğer bu oturumda kapatıldıysa ASLA gösterme
    if (wasClosedThisSession()) {
      hidePopup(popup);
      return;
    }

    // Tema bazen class ile gizliyor
    popup.classList.remove("hidden", "is-hidden", "hide", "d-none");
    popup.removeAttribute("hidden");
    popup.setAttribute("aria-hidden", "false");

    // Inline display none varsa kaldır
    if (popup.style && popup.style.display === "none") {
      popup.style.display = "";
    }

    // Bazı temalarda hazır olunca görünür yapan class bekleniyor
    document.documentElement.classList.add("nt-popup-ready");
  }

  function closeAndLock(popup) {
    // X / overlay / ESC ile kapatınca:
    // - popup kapansın
    // - aynı sayfa oturumunda tekrar açılmasın
    markClosedThisSession();
    hidePopup(popup);
  }

  function ensureCloseButton(popup) {
    if (!popup) return;

    var inner = getInnerEl(popup);
    if (inner.querySelector(".valentine-close")) return;

    var btn = document.createElement("button");
    btn.className = "valentine-close";
    btn.type = "button";
    btn.setAttribute("aria-label", "Close popup");
    btn.innerHTML = "&times;"; // ×

    btn.addEventListener("click", function (e) {
      e.preventDefault();
      e.stopPropagation();
      closeAndLock(popup);
    });

    inner.appendChild(btn);
  }

  function bindOverlayClose(popup) {
    if (!popup) return;

    popup.addEventListener("click", function (e) {
      // sadece overlay'e tıklayınca kapansın
      if (e.target === popup) closeAndLock(popup);
    });
  }

  function bindEscClose(popup) {
    if (!popup) return;

    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape") closeAndLock(popup);
    });
  }

  // Tema popup'ı sonradan tekrar açmaya çalışırsa tekrar kapat
  function enforceClosedIfNeeded(popup) {
    if (!popup) return;
    if (!wasClosedThisSession()) return;

    // Tema display/opacity/class ile açsa bile kapat
    if (popup.style.display !== "none") {
      hidePopup(popup);
    }
  }

  let started = false;

  function boot() {
    if (!isHome()) return;

    var popup = getPopupEl();
    if (!popup) return;

    // Bu oturumda kapatıldıysa, tema ne yaparsa yapsın kapalı kalsın
    enforceClosedIfNeeded(popup);

    // Eventleri bir kere bağla
    if (!started) {
      started = true;
      ensureCloseButton(popup);
      bindOverlayClose(popup);
      bindEscClose(popup);

      // Tema/class/style değişikliklerini izleyip kapalıysa tekrar kapat
      const obs = new MutationObserver(function () {
        var p = getPopupEl();
        if (!p) return;
        enforceClosedIfNeeded(p);
      });
      obs.observe(document.documentElement, { childList: true, subtree: true, attributes: true });
    }

    // Popup'ı görünür yap (ama kapatıldıysa showPopup zaten göstermeyecek)
    setTimeout(function () {
      showPopup(popup);
      // showPopup sonrası tema tekrar açmaya kalkarsa engelle
      enforceClosedIfNeeded(popup);
    }, 1000);
  }

  // Popup sonradan ekleniyorsa yakala
  var rootObs = new MutationObserver(function () {
    boot();
  });
  rootObs.observe(document.documentElement, { childList: true, subtree: true });

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
